export const COUNTDOWN_TIMER_DISABLED = 0;
export const COUNTDOWN_TIMER_5_SECONDS = 5;
export type CountdownTimerValues = 0 | 5;
